
import { useStore } from '@/store'
import * as THREE from 'three'
import { defineComponent, inject, onUnmounted } from 'vue'
import { computed, watch } from 'vue'
import MaterialCreateService from '@/services/Three/material-create.service'
import TextureLoadService from '@/services/Three/texture-load.service'
import { backFragmentShaderString } from '@/shaders/backFragment'
import References from '@/singletons/references'
import backSettings from '@/settings/back-settings.json'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'ThreeRandselBack',
  setup() {
    const store = useStore()
    const emitter: any = inject('emitter')
    const isBagLoaded = computed(() => store.getters.isBagLoaded)
    const isSceneLoaded = computed(() => store.getters.isSceneLoaded)
    const configBackId = computed(() => store.getters.configBackId)
    const isRenderer = inject('isRenderer') as boolean
    const materialCreateService: MaterialCreateService = new MaterialCreateService()
    let textureLoadService: TextureLoadService

    emitter.on('updateConfig', updateOption)

    // prettier-ignore
    watch(() => isSceneLoaded.value, (_) => {
        try {
          initTextureLoadService()
          let mat = materialCreateService.createMaterial(backFragmentShaderString, true, true, isRenderer)
          mat.uniforms.backColor = { value: materialCreateService.createColor(0xFFFFFF) };
          mat.uniforms.backTexture = { value: null };
          mat.uniforms.normalMap.value = null;
          textureLoadService.loadImage('default/back', function(tex) {
            mat.uniforms.backTexture.value = tex
          })
          textureLoadService.loadImage('default/back_n', function(tex) {
              mat.uniforms.normalMap.value = tex;
          })
          mat.uniforms.normalScale.value = new THREE.Vector2(-0.5, -0.5)
          mat.uniforms.roughness.value = 1;
          References.instance.setBackMaterial(mat)
        }
        catch(err) {
          SentrySingleton.instance.captureException(err)
        }
      }
    )

      function initTextureLoadService() {
      if (!textureLoadService || textureLoadService == undefined) {
        textureLoadService = new TextureLoadService(References.instance.getSceneReferences().maxAnisotropy)
      }
    }

    // prettier-ignore
    watch(() => isBagLoaded.value, (_) => { References.instance.getBagReferences().back.material = References.instance.getBackMaterial() })
    // prettier-ignore
    watch(() => configBackId.value, (_) => { updateOption() })

    function updateOption() {
      try {
        initTextureLoadService()
        if (configBackId.value) {
          setBack(backSettings.backColors.find((x: any) => x.id == configBackId.value))
        } else {
          setBack(backSettings.backColors.find((x: any) => x.default && x.default === true))
        }
      } catch (err) {
        SentrySingleton.instance.captureException(err)
      }
    }

    function setBack(obj: any) {
      References.instance.getBackMaterial().uniforms.backColor.value = materialCreateService.createColor(obj.value)
    }

    onUnmounted(() => {
      emitter.off('updateConfig', updateOption)
    })

    return {
      isBagLoaded,
      isSceneLoaded,

      configBackId
    }
  }
})
